import React, { useState } from "react";
import ContainerRoles from "../Mob/components/roles/roles-container";
import { ReactComponent as RolesIcon } from "../../assets/elevva-pro-icons/ICON_GESTION_ROLES.svg";

export default function AdministrationRoles() {
  const [modalListRoles, setModalListRoles] = useState(false);
  const isAdmin = localStorage.elevva_role == 10;

  return (
    <div
      className={`admin-roles-container d-flex flex-column gap-2 align-items-center justify-content-center ${isAdmin ? "enabled" : "disabled"}`}
    >
      <div className="admin-roles-header d-flex flex-column gap-2 align-items-center justify-content-center">
        <span className="admin-roles-icon">
          <RolesIcon />
        </span>
        <span className="admin-roles-title">Gestión rol de Usuarios</span>
      </div>

      <div className="admin-roles-actions">
        <button
          disabled={!isAdmin}
          className="admin-roles-button"
          onClick={() => setModalListRoles(true)}
        >
          Gestionar Usuarios
        </button>
      </div>

      {modalListRoles && (
        <ContainerRoles onClose={() => setModalListRoles(false)} />
      )}
    </div>
  );
}
